export default __webpack_public_path__ + "static/media/test_img1.c73052c1.png";